import { Route, Routes } from "react-router";

import { IdentityProviderChooser, SystemStatusPage } from "@nens/ranalib";

import { InvitationAcceptPage } from "@/lib/auth";

interface NotLoggedInRoutesProps {
  tenant: string;
  setIdentityProvider: (provider: string) => void;
}

export const LOGGED_OUT_ROUTE = "logged-out";

export function NotLoggedInRoutes({ tenant, setIdentityProvider }: NotLoggedInRoutesProps) {
  return (
    <Routes>
      <Route
        path={`/${LOGGED_OUT_ROUTE}`}
        element={<SystemStatusPage variant="logged-out" tenant={tenant} />}
      />
      <Route path="/invitations/:invitationId/accept" element={<InvitationAcceptPage />} />
      <Route
        path="*"
        element={
          <IdentityProviderChooser tenant={tenant} setIdentityProvider={setIdentityProvider} />
        }
      />
    </Routes>
  );
}
